<template>
    <div>
        <ul class="option-list">
            <li class="small-gray">
                月初(1，2，3号)充值时，运营商侧订单积压，导致充值成功后上网功能可能会延迟48小时恢复。
                月底最后一天运营商侧充值系统是关闭状态。
                基于以上原因，请避开月初或月末最后一天执行充值操作。
                我们在努力提高月初月末充值成功及时性。给您带来不便，敬请谅解。
            </li>
            <li>
                <h3>选择充值类型（套餐）</h3>
                <RadioGroup class="margin-top-10" size="large" type="button" v-model="rechargeConfig.offerid" @on-change="onPackChange">
                    <Radio v-for="pack in rechargeConfig.packageOptions" :key="pack.offerid" :title="pack.name" :label="pack.offerid">{{pack.name.substr(pack.name.lastIndexOf('-')+1)}}-{{rechargeConfig.rechargeTypes[pack.type]}}</Radio>
                </RadioGroup>
            </li>
            <template v-if="rechargeConfig.offerid">
                <li >
                    <span class="text-font-size">单价：</span>
                    <s> <span class="text-font-size">￥{{rechargeConfig.packageOptions[rechargeConfig.offerid].originPrice}}</span></s>
                    <span class="color-orage"> ￥{{rechargeConfig.packageOptions[rechargeConfig.offerid].price}}</span>
                </li>
                <li v-if="rechargeConfig.packageOptions[rechargeConfig.offerid].type === 'A'">
                    <span class="text-font-size">续期至：</span>
                    <span class="text-font-size"> <DatePicker type="month" :options="dateOptions" placeholder="充值到..." style="width: 200px" @on-change="onExpireDateChoose"></DatePicker></span>
                    <span class="small-gray" v-if="rechargeConfig.toDate"> [ 套餐生效至：{{rechargeConfig.toDate.pattern('yyyy-MM-dd HH:mm:ss')}} ]</span>
                </li>
                <li v-if="rechargeAmount > 0">
                    <span class="text-font-size">总价：</span>
                    <s> ￥{{(rechargeConfig.packageOptions[rechargeConfig.offerid].originPrice *
                        rechargeAmount).toFixed(2)}}</s>
                    <span class="color-orage"> ￥{{(rechargeConfig.packageOptions[rechargeConfig.offerid].price * rechargeAmount).toFixed(2)}}</span>
                </li>
                <li>
                    <span class="text-font-size">付款方式：</span>
                    <RadioGroup v-model="rechargeConfig.payWay">
                        <Radio label="0">电梯云账户付款</Radio>
                        <Radio label="1" disabled title="暂未开通">线下支付</Radio>
                        <Radio label="2" disabled title="暂未开通">微信支付</Radio>
                        <Radio label="3" disabled title="暂未开通">支付宝支付</Radio>
                    </RadioGroup>
                </li>
                <li style="text-align: right"><Button type="warning" @click="submitOrder">提交订单</Button></li>
            </template>
        </ul>
        <Divider></Divider>
        <Card v-for="sim in list" :key="sim.iccid" class="margin-top-10">
            <Row>
                <Col span="18">
                    <ul>
                        <li title="ICCID"><Icon type="md-card" /> {{sim.iccid}}</li>
                        <li title="所属电梯"><Icon type="md-map" /><span class="small-gray"> {{getDeviceName(sim)}}</span></li>
                        <li title="套餐截止日期"><Icon type="md-calendar" /> <span class="small-gray"> {{sim.card_status === '未激活' ? sim.card_status:new Date(sim.expire_date).pattern('yyyy-MM-dd')}}</span></li>
                    </ul>
                </Col>
                <Col span="6">
                    <i-circle v-if="sim.flow_total" :percent="(100*sim.flow_used/sim.flow_total)" :stroke-color="getProcessColor(100*sim.flow_used/sim.flow_total)">
                        <span class="demo-Circle-inner">{{getFlowShowValue(sim.flow_used)}}/{{getFlowShowValue(sim.flow_total)}}</span>
                    </i-circle>
                </Col>
            </Row>

        </Card>
        <template>
            <lg-modal title="SIM卡充值订单确认"  :show="modal.show" :loading="modal.loading" @on-submit="onOrderSubmit"
                      @on-cancel="modal.loading=false; modal.show=false;" :mask-closable="false">
                <CellGroup>
                    <Cell title="订单类型" :extra="modal.content.event"/>
                    <Cell title="充值类型" :extra="modal.content.rechargeType" />
                    <Cell title="套餐-编号" :extra="modal.content.rechargeOffer.offerid" />
                    <Cell title="套餐-名称" :extra="modal.content.rechargeOffer.name" />
                    <Cell title="套餐-流量" :extra="modal.content.rechargeOffer.flow" />
                    <Cell title="套餐-单价" :extra="`￥${modal.content.rechargeOffer.price} （原价：￥${modal.content.rechargeOffer.originPrice}）`" />
                    <Cell title="订单总量" :extra="rechargeAmount.toString()"/>
                    <Cell title="订单总价" :extra="`￥${(modal.content.rechargeOffer.price * rechargeAmount).toFixed(2)}`" />
                </CellGroup>
                <Input type="textarea" v-model="modal.remarkForOrder" :rows="2" placeholder="备注…"/>
            </lg-modal>
            <Spin v-if="loading"></Spin>
        </template>
    </div>
</template>

<script>
    import util from "../../../libs/util";
    import LgModal from "../../my-components/lg-modal";
    let now = new Date();
    let monthNow = new Date(now.getFullYear(), now.getMonth(), 1, 0,0,0);
    export default {
        name: "recharge-list",
        components: {LgModal},
        props: {
            ids: Array,
            isSingle:Boolean   //  单个缴费 加载loadata查询
        },
        data () {
            return {
                loading: false,
                list: [{}],
                monthRanges: [],
                rechargeConfig: {
                    packageOptions: {},
                    rechargeTypes: {
                        A: '包月续期',
                        B: '本月叠加'
                    },
                    offerid: '',
                    payWay: '0',
                    toDate: null
                },
                dateOptions: {
                    disabledDate (date) {
                        return date && (date.valueOf() < monthNow.valueOf());
                    }
                },
                modal: {
                    show: false,
                    loading: false,
                    content: {
                        event: 'SIM卡充值',
                        rechargeType: '',
                        rechargeOffer: {},
                        simCards: [],
                        endDate: null
                    },
                    remarkForOrder: ''
                }
            }
        },
        computed: {
            rechargeAmount () {
                if (!this.rechargeConfig.offerid) return 0;
                if (this.rechargeConfig.packageOptions[this.rechargeConfig.offerid].type === 'B') {
                    return this.list.filter(sim => !!sim.active_time).length;
                }
                return this.monthRanges.length > 0 ? this.monthRanges.reduce((previousValue, currentValue) => previousValue+currentValue) : 0;
            }
        },
        methods: {
            onOrderSubmit () {
                this.modal.content.endDate = this.rechargeConfig.toDate ? this.rechargeConfig.toDate.getTime(): null;
                util.ajax.get('/getSessionKey').then(res => {
                    if (res.code) return;
                    let jiamiData = util.encrypt(Date.now().toString(), res.data);
                    util.ajax.post('/sim/rechargeorder', {
                        others: window.btoa(encodeURIComponent(JSON.stringify({
                            orderContent: this.modal.content,
                            priceTotal: (this.modal.content.rechargeOffer.originPrice * this.rechargeAmount).toFixed(2),
                            priceReal: (this.modal.content.rechargeOffer.price * this.rechargeAmount).toFixed(2),
                            buyerRemark: this.modal.remarkForOrder,
                            payWay: this.rechargeConfig.payWay,
                            amount: this.rechargeAmount
                        }))),
                        data: jiamiData
                    }).then(res => {
                        this.modal.loading=false;
                        this.modal.show=false;
                        this.$emit('order-created')
                    }).catch(e => {
                        this.modal.loading=false;
                    })
                })
            },
            onExpireDateChoose(dateStr) {
                let date = new Date(dateStr);
                date.setMonth(date.getMonth() + 1);
                date.setDate(date.getDate() - 1);
                date.setHours(23);
                date.setMinutes(59);
                date.setSeconds(59);
                this.$set(this.rechargeConfig, 'toDate', date);
                this.monthRanges = [];
                this.list.forEach(sim => {
                    let epDate = new Date(sim.expire_date);
                    if (date.getTime() > epDate.getTime()) {
                        this.monthRanges.push(
                            (date.getFullYear()*12 + date.getMonth())-(epDate.getFullYear()*12 + epDate.getMonth())
                        );
                    } else {
                        this.monthRanges.push(0);
                    }
                })
            },
            loadConfig () {
                util.ajax.get('/settings/get', {params: {field: 'aliyun_config'}}).then(res => {
                    util.parseJSONResult(res.data, 'aliyun_config');
                    res.data.aliyun_config.simPackages.forEach(pack => {
                        this.rechargeConfig.packageOptions[pack.offerid] = pack;
                    });
                })
            },
            loadData () {
                this.loading = true;
                util.ajax.get('/sim/rechargelist', {params: {ids: this.ids}}).then(res => {
                    this.loading = false;
                    res.data.forEach(sim => {util.parseJSONResult(sim)})
                    this.list.splice(0, this.list.length, ...res.data);
                }).catch(e => {
                    this.loading = false;
                })
            },
            getDeviceName (sim) {
                if (!sim.device_name) return '未绑定电梯';
                return `${sim.dname} [${sim.cname?sim.cname:''}-${sim.j_location&&sim.j_location.building?sim.j_location.building.name:''}-${sim.j_location&&sim.j_location.unit?sim.j_location.unit.name:''}]`
            //     <span>{{sim.dname}}</span>
            //     <div slot="content">
            //         <p>{{sim.cname}} {{sim.j_location.building.name}} {{sim.j_location.unit.name}} {{sim.j_location.door.name}} {{sim.dname}}</p>
            //     <p>{{sim.j_region.province.name}} {{sim.j_region.city.name}} {{row.j_region.area.name}}</p>
            //     </div>
            //     return "asdf"
            },
            getFlowShowValue (value) {
                if (value >= 1024 * 1024) return (value/1024/1024).toFixed(2) + 'GB';
                if (value >= 1024) return (value/1024).toFixed(2) + 'MB';
                if (value > 0) `${value}KB`;
                return 0;
            },
            getProcessColor (percent) {
                // let percent = Math.round((pool.flow_used || 0) * 100 / (pool.card_num* pool.unit_size));
                let colorStart = [0,255,0];
                let colorEnd = [255,0,0];
                let stepR = (colorEnd[0] - colorStart[0])/100;
                let stepG = (colorEnd[1] - colorStart[1])/100;
                let stepB = (colorEnd[2] - colorStart[2])/100;

                let color = [Math.round(colorStart[0] + stepR * percent), Math.round(colorStart[1] + stepG * percent), Math.round(colorStart[2] + stepB * percent)]

                color = `#${color[0].toString(16).padStart(2, '0')}${color[1].toString(16).padStart(2, '0')}${color[2].toString(16).padStart(2, '0')}`;
                return color;
            },
            submitOrder () {
                let orderContent = {
                    event: 'SIM卡充值',
                    rechargeType: this.rechargeConfig.packageOptions[this.rechargeConfig.offerid].type === 'A' ? '套餐续期' : '流量叠加',
                    rechargeOffer: this.rechargeConfig.packageOptions[this.rechargeConfig.offerid],
                    simCards: []
                }
                this.list.forEach((card, index) => {
                    let sim = {
                        iccid: card.iccid
                    }
                    if (orderContent.rechargeType === '套餐续期') sim.amount = this.monthRanges[index];
                    orderContent.simCards.push(sim)
                })
                this.modal.content = orderContent;
                this.modal.show = true;
            },
            onPackChange (offerid) {
                this.rechargeConfig.toDate = null;
                this.monthRanges = [];
            }
        },
        mounted () {
            this.loadConfig();
            if(this.isSingle) this.loadData();
        }
    }
</script>

<style scoped>
    .small-gray {
        color: #aaa;
        font-size: 12px;
    }
    .color-orage {
        color: orange;
        font-weight: bolder;
    }
    .option-list>li {
        margin-bottom: 10px;
    }
</style>